import { LangIds, Languages, getLang } from "../langs/langs";

function getErrLang(err: string, lang: Languages){
	var langId = LangIds.SERVER_Err;

	switch (err){
		case 'front_fail':
			langId = LangIds.SERVER_Err_front_fail;
			break;

		case 'front_exp':
			langId = LangIds.SERVER_Err_front_exp;
			break;

		case 'front_change':
			langId = LangIds.SERVER_Err_front_change;
			break;

		case 'back_fail':
			langId = LangIds.SERVER_Err_back_fail;
			break;
	
		case 'back_exp':
			langId = LangIds.SERVER_Err_back_exp;
			break;
	
		case 'back_change':
			langId = LangIds.SERVER_Err_back_change;
			break;

		case 'face_in':
			langId = LangIds.SERVER_Err_face_in;
			break;

		case 'face_liveness':
			langId = LangIds.SERVER_Err_face_liveness;
			break
		
		case 'face_ban':
			langId = LangIds.SERVER_Err_face_ban;
			break;
						
		case 'face_spoof':
			langId = LangIds.SERVER_Err_face_spoof;
			break;

		case 'child_in':
			langId = LangIds.SERVER_Err_child_in;
			break;

		case 'child_liveness':
			langId = LangIds.SERVER_Err_child_liveness;
			break;

		case 'child_ban':
			langId = LangIds.SERVER_Err_child_ban;
			break;

		case 'child_spoof':
			langId = LangIds.SERVER_Err_child_spoof;
			break;
							
		case 'child_old':
			langId = LangIds.SERVER_Err_child_old;
			break;

		default:
			break;
	}

	return getLang(langId, lang);
}

function getErrExtLang(err: string, lang: Languages){
	var langId = LangIds.SERVER_Err;

	switch (err){
		case 'front_fail':
			langId = LangIds.SERVER_Err_front_fail_ext;
			break;

		case 'front_exp':
			langId = LangIds.SERVER_Err_front_exp_ext;
			break;

		case 'front_change':
			langId = LangIds.SERVER_Err_front_change_ext;
			break;

		case 'back_fail':
			langId = LangIds.SERVER_Err_back_fail_ext;
			break;
	
		case 'back_exp':
			langId = LangIds.SERVER_Err_back_exp_ext;
			break;
	
		case 'back_change':
			langId = LangIds.SERVER_Err_back_change_ext;
			break;

		case 'face_in':
			langId = LangIds.SERVER_Err_face_in_ext;
			break;

		case 'face_liveness':
			langId = LangIds.SERVER_Err_face_liveness_ext;
			break
		
		case 'face_ban':
			langId = LangIds.SERVER_Err_face_ban_ext;
			break;
						
		case 'face_spoof':
			langId = LangIds.SERVER_Err_face_spoof_ext;
			break;

		case 'child_in':
			langId = LangIds.SERVER_Err_child_in_ext;
			break;

		case 'child_liveness':
			langId = LangIds.SERVER_Err_child_liveness_ext;
			break;

		case 'child_ban':
			langId = LangIds.SERVER_Err_child_ban_ext;
			break;

		case 'child_spoof':
			langId = LangIds.SERVER_Err_child_spoof_ext;
			break;
							
		case 'child_old':
			langId = LangIds.SERVER_Err_child_old_ext;
			break;

		default:
			return '';
	}

	return getLang(langId, lang);
}

function ServerSend(data: FormData, lang: Languages, sessionId: string, onFinish: () => void, onRecieve: (obj: any) => void, onFail: (msg: string, msgExt: string) => void) {
  
	//const url = new URL('http://localhost:80/innovatrics/api/v1/iframe/script.php');
	const url = new URL('https://trucrowd.tech/api/v1/iframe/script.php');

	const xhr = new XMLHttpRequest();
	xhr.open("POST", url, true);
	xhr.responseType = "text";
	
	xhr.onreadystatechange = () => {
		if (xhr.readyState === XMLHttpRequest.DONE) {
			var ret = false;
			var err = '';
			var err_ext = '';
			var msg = '';
			var msgExt = '';
			onFinish();
			//alert(xhr.responseText);
			if (xhr.status === 0 || (xhr.status >= 200 && xhr.status < 400)) {
				if(xhr.responseText !== null && xhr.responseText !== ''){
					const obj = JSON.parse(xhr.responseText);
					if(obj.version === 1 && obj.error === false){
						ret = true;
						onRecieve(obj);
					}

					if(obj.error){
						if(obj.err_msg !== '')
							err = obj.err_msg;

						if(obj.err_msg_ext !== '')
							err_ext = obj.err_msg_ext;

						msg = getErrLang(err, lang);
						msgExt = getErrExtLang(err_ext, lang);
					}
				}
			} 
			if(ret === false){
				onFail(msg, msgExt);
			}
		}
	};

	data.append("version", "1");
	data.append("sessionId", sessionId);
	xhr.send(data);
  };

export default ServerSend;
